import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {AppState, selectActivePublicationState} from '@store/app.states';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '@app/services/auth/auth.service';
import {Observable} from 'rxjs';
import * as activePublication from '@app/components/publications/create-publication/_store/active-publication.reducers';
import {distinctUntilChanged} from 'rxjs/operators';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {UserContext} from '@models/user';
import {UntypedFormControl} from '@angular/forms';
import {PublicationLinksService} from '@app/components/publications/publication-sideBar/publication-links/publication-links.service';
import {ReviewSyncCintCommunity} from '@app/components/publications/create-publication/_store/active-publication.actions';
import {ToastrService} from 'ngx-toastr';
import {ClipboardService} from 'ngx-clipboard';
import {CommunitiesService} from '../../../../../@shared/inbe-communities-selector/communities.service';

@Component({
    selector: 'app-publication-links',
    templateUrl: './publication-links.component.html',
    styleUrls: ['./publication-links.component.scss'],
    standalone: false
})
export class PublicationLinksComponent extends OnDestroyMixin implements OnInit {

  pubUuid: string = null;

  userContext: UserContext = this.authService.getContext();

  // obsSelectedCommunities$: Observable<CommunitiesModel[]> = this.store.pipe(select(getSelectedCommunities), untilComponentDestroyed(this));

  selectedCommunities: number[] = [];

  cintCommunitySelected = new UntypedFormControl(true);

  cintCommunityId: number = null;
  cintProjectSlug: string = null;
  cintReviewDone = false;

  selectedLang = new UntypedFormControl(this.translate.currentLang);
  forceLang = new UntypedFormControl(false);
  askLang = new UntypedFormControl(false);
  forceLangParam = null;

  utms: { key: string, value: string }[] = [];
  // addUtmInfos = new FormControl(false);

  modeTestSelected = new UntypedFormControl(false);
  modePublicationOnly = new UntypedFormControl(true);

  langsAvailables = this.translate.langs;
  
  // Informations complètes des langues avec drapeaux
  languagesInfo: { [key: string]: { name: string; flag: string } } = {
    fr: { name: 'Français', flag: '🇫🇷' },
    en: { name: 'English', flag: '🇬🇧' },
    nl: { name: 'Nederlands', flag: '🇳🇱' },
    de: { name: 'Deutsch', flag: '🇩🇪' },
    es: { name: 'Español', flag: '🇪🇸' },
    it: { name: 'Italiano', flag: '🇮🇹' },
    pt: { name: 'Português', flag: '🇵🇹' },
  };
  
  getLanguageInfo(code: string): { name: string; flag: string } {
    return this.languagesInfo[code] || { name: code.toUpperCase(), flag: '🌐' };
  }

  public getActivePublication$: Observable<activePublication.State> = this.store
    .pipe(
      select(selectActivePublicationState),
      distinctUntilChanged(),
      untilComponentDestroyed(this),
    );


  constructor(
    private store: Store<AppState>,
    private translate: TranslateService,
    private authService: AuthService,
    private publicationLinksService: PublicationLinksService,
    private toastr: ToastrService,
    private clipboard: ClipboardService,
    public communitiesService: CommunitiesService,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {

    this.getActivePublication$.pipe(untilComponentDestroyed(this)).subscribe((data) => {

      if (data.datas) {

        this.pubUuid = data.datas.uuid;

        if (!data.datas.generalInfo.contributors.inbe) {
          this.selectedCommunities = [];
        } else {
          this.selectedCommunities = data.datas.generalInfo.selectedCommunities;
        }

        this.utms = data.datas?.linkInfos?.utm || [];
        // if (data.datas?.linkInfos?.utm?.length > 0) {
        //   // this.addUtmInfos.enable();
        //   this.utms = data.datas.linkInfos.utm;
        // } else {
        //   // this.addUtmInfos.disable();
        //   this.utms = [];
        // }

        this.cintCommunitySelected.setValue(data.datas.generalInfo.contributors.cint);

        if (!data.datas.generalInfo.contributors.cint) {
          this.cintCommunitySelected.disable();
        } else {

          if (!data.uxInteractions.review.cintCommunity.projectSlug) {

            // console.log(data.uxInteractions.review.cintCommunity.querying);

            if (!data.uxInteractions.review.cintCommunity.querying && !this.cintReviewDone) {

              this.store.dispatch(
                new ReviewSyncCintCommunity({
                  action: 'check',
                  cintProjectId: data.datas.generalInfo.contributors.cintProjectId,
                  cintTokenComplete: data.datas.generalInfo.contributors.cintTokens.complete,
                  cintTokenScreenOut: data.datas.generalInfo.contributors.cintTokens.screenout,
                }),
              );

              this.cintReviewDone = true;

            }

          }
          this.cintCommunityId = data.datas.generalInfo.contributors.cintCommunityId;
        }

      }
      
      this.cdr.detectChanges();

    });

    // this.obsSelectedCommunities$.pipe(untilComponentDestroyed(this)).subscribe((data) => {
    //   if (data?.length > 0) {
    //     this.selectedCommunities = [data[0].communityId];
    //   } else {
    //     this.selectedCommunities = [];
    //   }
    //
    // });

    this.selectedLang.valueChanges.pipe(untilComponentDestroyed(this)).subscribe(() => {
      this.changeForceLang();
    });
    this.forceLang.valueChanges.pipe(untilComponentDestroyed(this)).subscribe(() => {
      this.changeForceLang();
    });
    this.askLang.valueChanges.pipe(untilComponentDestroyed(this)).subscribe(() => {
      this.changeForceLang();
    });

  }

  changeForceLang() {

    if (this.forceLang.value) {
      this.forceLangParam = this.selectedLang.value;
    } else {
      this.forceLangParam = null;
    }

  }

  getUrlLink(projectSlug: string, comId: number, isCint: boolean = false, v2Link = false): string {

    const forceLang = this.forceLang?.value;
    const askLang = this.askLang?.value;

    return this.publicationLinksService.getPublicationPublicLink({
      pubUuid: this.pubUuid,
      lang: this.selectedLang.value as string,
      projectSlug,
      comId,
      isCint,
      testMode: this.modeTestSelected.value as boolean,
      directMode: this.modePublicationOnly.value as boolean,
      utms: this.utms,
      forceLang: this.forceLangParam,
      v2Link,
      askLang,
    });

  }

  copyClipBoardUrl(url): void {
    this.clipboard.copy(url);

    this.toastr.info(this.translate.instant('Lien copié dans le presse papier.'), this.translate.instant('Presse papier'), {
      timeOut: 2000,
      progressBar: true,
    });

  }

  gotoUrl(url): void {
    // console.log(url);
    window.open(url, '_blank');
  }

  enableTestMode(): void {
    this.modeTestSelected.setValue(true);
    this.modePublicationOnly.setValue(false);
  }


}
